<template>
  <nav class="nav" ref="topMenu">
    <div class="wrapper cf">
      <div class="nav__hamburger" @click="hamburgerClick"></div>
      <div class="nav__block" :class="{'active': this.currentMenu, 'mobile': this.menu_mobile}" ref="topMenuBlock">
        <div class="nav__close" @click="hamburgerClick"></div>
        <ul class="nav__list">
          <li class="nav__item" v-for="(itemMenu, indexListMenu) in listMenu" :key="indexListMenu">
            <router-link :to="itemMenu.link" :title="itemMenu.name" class="nav__link" :class="{'selected': isActive(itemMenu)}" @click.native="menuClose()">{{itemMenu.name}}</router-link>
          </li>
        </ul>
      </div>
    </div>
  </nav>
</template>

<script>
import scroll from '../js/body-scroll'

export default {
  name: "HeaderMenu",
  data () {
    return {
      thisPage: '',
      listMenu: [
        {name:'Резюме', link:'/resume/'},
        {name:'Портфолио', link:'/portfolio/'},
        {name:'Полезные ссылки', link:'/links/'},
        {name:'Тестовые задания', link:'/tests/'},
        {name:'Контакты', link:'/contacts/'}
      ],
      currentMenu: false,
      menu_mobile: false
    }
  },
  methods: {
    listMenuCreate () {
      return this.listMenu;
    },
    isActive (itemMenu) {
      return this.$route.path.indexOf(itemMenu.link) === 0
    },
    menuShowHide () {
      this.currentMenu = !this.currentMenu;
      if (this.currentMenu){
        scroll.hideScroll()
      } else {
        scroll.showScroll()
      }
    },
    hamburgerClick ()  {
      setTimeout(() => this.menuShowHide(), 5)
    },
    menuClose () {
      if (this.currentMenu){
        scroll.showScroll()
        this.currentMenu = false
      }
    },
    handleResize () {
      setTimeout(() => this.menu_mobile = window.innerWidth < 1024, 5)
      this.menuClose()
    }
  },
  mounted () {
    this.listMenuCreate()
  },
  created() {
    window.addEventListener('resize', this.handleResize)
    this.handleResize()
  },
  destroyed() {
    window.removeEventListener('resize', this.handleResize)
  }
}
</script>

<style lang="scss" scoped>
  .nav {
    position: relative;
    clear: both;
    background: $bg-color;
    border-top: 1px solid #ffffff;

    &:before, &:after {
      content: '';
      position: absolute;
      left: 0;
      width: 100%;
      height: 1px;
      background: $bg-color;
    }

    &:before {
      top: -2px;
    }

    &:after {
      bottom: -2px;
    }

    &__hamburger {
      position: relative;
      display: block;
      float: right;
      width: 20px;
      height: 16px;
      margin: 12px 0;
      border-top: 2px solid #ffffff;
      border-bottom: 2px solid #ffffff;
      cursor: pointer;

      &:before {
        content: '';
        position: absolute;
        left: 0;
        top: 50%;
        width: 100%;
        height: 2px;
        margin-top: -1px;
        background: #ffffff;
      }

      @media screen and (min-width: 1024px){
        display: none;
      }
    }

    &__close {
      display: block;
      position: relative;
      float: right;
      width: 30px;
      height: 30px;
      margin: 5px 5px 0 0;
      cursor: pointer;

      &:before, &:after {
        content: '';
        position: absolute;
        top: 0;
        left: 50%;
        margin-left: -1px;
        width: 2px;
        height: 30px;
        background: $bg-color;
      }

      &:before {
        transform: rotate(45deg);
      }

      &:after {
        transform: rotate(-45deg);
      }

      @media screen and (min-width: 1024px){
        display: none;
      }
    }

    &__block {
      position: fixed;
      top: 0;
      right: 0;
      z-index: 100;
      width: 210px;
      height: 100%;
      border-left: 1px solid #dddddd;
      background: #ffffff;
      box-shadow: 0 0 10px rgba(0,0,0,.3);
      transform: translateX(110%);

      @media screen and (min-width: 1024px){
        position: relative;
        top: auto;
        right: auto;
        width: auto;
        height: auto;
        border: none;
        background: none;
        box-shadow: none;
        transform: translate(0);
        transition: none;
      }

      &.mobile {
        transition: transform linear .3s;
      }

      &.active {
        overflow-y: auto;
        transform: translateX(0);
      }
    }

    &__list {
      display: block;
      margin: 40px 0 0;
      padding: 0;
      font-size: 0;
      text-align: left;

      @media screen and (min-width: 1024px){
        text-align: center;
        margin: 0;
      }
    }

    &__item {
      position: relative;
      display: block;

      @media screen and (min-width: 1024px){
        display: inline-block;
      }

      & + & {
        margin: 1px 0 0;

        @media screen and (min-width: 1024px){
          margin: 0 0 0 1px;
        }
      }
    }

    &__link {
      position: relative;
      display: block;
      height: 35px;
      padding: 0 15px;
      @include font(15px, 35px, $bg-color);
      text-decoration: none;

      @media screen and (min-width: 1024px){
        display: inline-block;
        padding: 0 25px;
        border-radius: 10px 0 10px 0;
        transition: background .7s;
        @include font(15px, 35px, #ffffff);
      }

      &:hover, &.selected {
        text-decoration: none;
        background: #d6e3fc;
        color: $bg-color;

        @media screen and (min-width: 1024px){
          &:before, &:after {
            content: '';
            position: absolute;
            width: 50%;
            height: 1px;
            background: $bg-color;
          }

          &:before {
            top: 0;
            left: 0;
          }

          &:after {
            bottom: 0;
            right: 0;
          }
        }
      }
    }
  }
</style>